<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="chapter-title-break" id="_idParaDest-1"><a id="_idTOCAnchor-26"></a>Table of Contents</p>
</div>
<div class="_idGenObjectStyleOverride-1">
<p class="TOC-chapter-italic"> <a href="#/9781630472863_EPUB5#_idTOCAnchor-14">Preface</a></p>
<p class="TOC-chapter-italic"> <a href="#/9781630472863_EPUB6#_idTOCAnchor-13">Acknowledgments</a></p>
<p class="TOC-chapter-italic"> <a href="#/9781630472863_EPUB7#_idTOCAnchor-12">Introduction</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB8#_idTOCAnchor-25">Chapter </a>1	<a href="#/9781630472863_EPUB8#_idTOCAnchor-11">The Bad Gene</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB9#_idTOCAnchor-24">Chapter 2</a> <a href="#/9781630472863_EPUB9#_idTOCAnchor-10">A Social Affair</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB10#_idTOCAnchor-23">Chapter 3</a> <a href="#/9781630472863_EPUB10#_idTOCAnchor-9">Breaking Point</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB11#_idTOCAnchor-22">Chapter 4</a> <a href="#/9781630472863_EPUB11#_idTOCAnchor-8">The Beginning of the End</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB12#_idTOCAnchor-21">Chapter 5</a> <a href="#/9781630472863_EPUB12#_idTOCAnchor-7">A False Start</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB13#_idTOCAnchor-20">Chapter 6</a> <a href="#/9781630472863_EPUB13#_idTOCAnchor-6">A Vicious Cycle</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB14#_idTOCAnchor-19">Chapter 7</a> <a href="#/9781630472863_EPUB14#_idTOCAnchor-5">Van’s House</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB15#_idTOCAnchor-18">Chapter 8</a> <a href="#/9781630472863_EPUB15#_idTOCAnchor-4">The Big Day</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB16#_idTOCAnchor-17">Chapter 9</a> <a href="#/9781630472863_EPUB16#_idTOCAnchor-3">Little Blessings</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB17#_idTOCAnchor-16">Chapter 10</a> <a href="#/9781630472863_EPUB17#_idTOCAnchor-2">God’s Promises Fulfilled</a></p>
<p class="TOC-Chapter-Title"><a href="#/9781630472863_EPUB18#_idTOCAnchor-15">Chapter 11</a> <a href="#/9781630472863_EPUB18#_idTOCAnchor-1">A New Perspective</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781630472863_EPUB-4.vue?12bd0554